   export let statusWs;
	
	export const userStatusMap = new Map();
	
 	export const setStatusWs = (status) => {
		statusWs = status;
	};
	
   export const getStatusWs = () => {
      return statusWs;
   };  
    

   export let chatWs;	
	
 	export const setChatWs = (status) => {
		chatWs = status;
	};
	
   export const getChatWs = () => {
      return chatWs;
   };   